import { doc, updateDoc, arrayUnion, arrayRemove } from 'firebase/firestore';

import { getFirestoreDb } from '../config/firebaseApp';

let cachedFcmToken: string | null = null;

export function getCachedFcmToken(): string | null {
  return cachedFcmToken;
}

export function setCachedFcmToken(token: string | null): void {
  cachedFcmToken = token;
}

/** `users/{uid}` belgesine token ekler (çoklu cihaz: `fcmTokens` dizisi). */
export async function saveUserFcmToken(uid: string, token: string): Promise<void> {
  const db = getFirestoreDb();
  await updateDoc(doc(db, 'users', uid), {
    fcmTokens: arrayUnion(token),
  });
  setCachedFcmToken(token);
}

/** Güvenli çıkış: bu cihazın token'ını diziden çıkarır. */
export async function removeUserFcmToken(
  uid: string,
  token: string | null = getCachedFcmToken(),
): Promise<void> {
  if (!token) {
    return;
  }
  const db = getFirestoreDb();
  await updateDoc(doc(db, 'users', uid), {
    fcmTokens: arrayRemove(token),
  });
  if (getCachedFcmToken() === token) {
    setCachedFcmToken(null);
  }
}
